import localStorageAvailable from "../../utils/localStorageAvailable";
import axios from "../../utils/axios";


const getLiveAndUpcomingEvents = async (
    user,
    event_status,
    vendor_id,
    page,
    page_size=300,
    label
) => {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable
        ? localStorage.getItem("accessToken")
        : "";
    const mode = localStorage.getItem('mode')

    const config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `/service/events_service/v1/events/event/all_events/vendor`,
        headers: {
            authorization: `Bearer ${accessToken}`,
            user,
        },
        params: { page, page_size, label, mode, event_status,
            //  vendor_id
             }

    };
    const response = await axios.request(config);
    return response.data;
};

export default getLiveAndUpcomingEvents;
